/* FACTS · Drei-Schritte-Stepper mit Zustands-Skala
   ------------------------------------------------------------------
   Regeln aus dem Section-Standard §8:
   - Zustaende (data-step 1..3) schalten NUR Attribute; alle Uebergaenge
     laufen im CSS auf transform/opacity.
   - Autoplay startet erst beim Eintritt in den Viewport (IO) und laeuft
     genau einmal; jede Nutzer-Interaktion bricht es ab.
   - prefers-reduced-motion: kein Autoplay, Zustaende springen. */
(function () {
  if (customElements.get('facts-three-steps')) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class FactsThreeSteps extends HTMLElement {
    connectedCallback() {
      this._viz = this.querySelector('[data-f3-viz]');
      this._steps = [].slice.call(this.querySelectorAll('[data-f3-step]'));
      this._steps.forEach(function (card, i) {
        card.querySelector('[data-f3-head]')
          .addEventListener('click', this._onClick.bind(this, i));
      }.bind(this));

      this._interacted = false;
      var auto = this.getAttribute('data-autoplay') === 'true' && !REDUCE;
      if (auto) {
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !this._played) {
              this._played = true;
              this._autoplay();
              this._io.disconnect();
            }
          }.bind(this));
        }.bind(this), { threshold: 0.45 });
        this._io.observe(this);
      } else {
        /* Ohne Autoplay startet die Skala im ersten Zustand, sobald sichtbar. */
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !this._played) {
              this._played = true;
              this._set(0);
              this._io.disconnect();
            }
          }.bind(this));
        }.bind(this), { threshold: 0.45 });
        this._io.observe(this);
      }
    }

    _autoplay() {
      var delay = parseInt(this.getAttribute('data-interval'), 10) || 1600;
      var self = this;
      this._set(0);
      this._t1 = setTimeout(function () { if (!self._interacted) self._set(1); }, delay);
      this._t2 = setTimeout(function () { if (!self._interacted) self._set(2); }, delay * 2);
    }

    _onClick(i) {
      this._interacted = true;
      clearTimeout(this._t1); clearTimeout(this._t2);
      this._set(i);
    }

    _set(i) {
      /* Die Marken samt Beschriftung stehen im Markup und werden ueber
         data-step im CSS ein- und ausgeblendet - kein Textknoten-Tausch. */
      if (this._viz) this._viz.setAttribute('data-step', String(i + 1));
      this._steps.forEach(function (card, j) {
        var head = card.querySelector('[data-f3-head]');
        if (j === i) {
          card.setAttribute('data-active', '');
          head.setAttribute('aria-expanded', 'true');
        } else {
          card.removeAttribute('data-active');
          head.setAttribute('aria-expanded', 'false');
        }
      });
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      clearTimeout(this._t1); clearTimeout(this._t2);
    }
  }
  customElements.define('facts-three-steps', FactsThreeSteps);
})();
